import React from 'react';
import { useFeatureFlags } from 'hooks';

export default function withFeatureFlags(requestedFlags) {
    return Component => props => {
        const [featureFlags] = useFeatureFlags(requestedFlags);
        return <Component {...props} {...featureFlags} />;
    };
}
